<script lang="ts">
    import {
        VpArrowDownIcon,
        VpArrowUpIcon,
    } from '@decathlon-experience/icons/svelte';

    import { trans } from '$assets/shop-translator.js';
    import cn from '$common/utils/cn';
    import Button from '$saga/components/Button.svelte';
    import type { OptionList } from '$saga/types/search.types';
    import CheckboxElement from '$saga/views/Search/components/CheckboxElement.svelte';
    import { debouncedHandleFilterChange } from '$saga/views/Search/utils';

    export let options: OptionList;
    export let formValue: string[];
    export let visibleLimit: number | undefined = undefined;

    let isShowingMore = false;
    let visibleOptions: OptionList = [];

    $: visibleOptions =
        null != visibleLimit && !isShowingMore
            ? options.slice(0, visibleLimit)
            : options;

    const toggleCheckbox = (optionElement: {
        value: string;
        label: string;
    }) => {
        if (formValue.find((value) => value === optionElement.value)) {
            formValue = formValue.filter(
                (value) => value !== optionElement.value,
            );
        } else {
            formValue = [...formValue, optionElement.value];
        }
        debouncedHandleFilterChange();
    };
</script>

{#each visibleOptions as optionElement (optionElement.value)}
    {@const isDisabled = optionElement.count === 0}
    <CheckboxElement
        label={`${optionElement.label} (${optionElement.count})`}
        subLabel={optionElement.subLabel}
        labelClass={cn('mr-m')}
        containerClass="leading-6 text-content-neutral hover:bg-commercial-neutral"
        isChecked={formValue.find((value) => value === optionElement.value) !=
            null}
        {isDisabled}
        onToggleCheck={() => toggleCheckbox(optionElement)}
    />
{/each}

{#if null != visibleLimit && options.length > visibleLimit}
    <div class="my-m flex items-center justify-center">
        <Button
            type="button"
            intent="tertiary"
            size="small"
            endIcon={isShowingMore ? VpArrowUpIcon : VpArrowDownIcon}
            on:click={() => (isShowingMore = !isShowingMore)}
        >
            {trans(isShowingMore ? 'common.see_less' : 'common.see_more')}
        </Button>
    </div>
{/if}
